@@ -0,0 +1,69 @@
<template>
  <div class="app-wrap">
    <header id='header'>
      <div class='inner'>
        <div class='col col1'>
          <a class='btnNavi prev'>
            <span @click.stop.prevent='backBtn' class='ico'>이전</span>
          </a>
        </div>
        <div class='col col2'>
          <h1>공지사항</h1>
        </div>
      </div>
    </header>
    <div class="noticeDetail">
      <div class="noticeDetailTop">
        <p class="noticeDetailTitle">{{detail.noticeTitle}}</p>
        <p class="noticeDetailRegDt">{{detail.regDt}}</p>
      </div>
      <div class="noticeDetailBot">
        <img :src="detail.noticeImageURL" class="noticeDetailImg" v-if="detail.noticeImageURL">
        <p class="noticeDetailTxt">{{detail.noticeContent}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import service from '@/backend/modnpay_app_api'
export default {
  components: { },
  data () {
    return {
      detail: {}
    }
  },

  mounted () {
    window.backBtn = () => {
      this.backBtn()
    }
    this.noticeDetail()
  },

  computed: {
    noticeSeq () {
      return this.$route.params.noticeSeq
    }
  },
  methods: {
    backBtn () {
      history.back()
    },
    async noticeDetail () {
      const req = {
        noticeSeq: this.noticeSeq
      }
      const { data } = await service.noticeDetail(req)
      if (data.resultCode == 0) {
        this.detail = data.noticeDto
      }
    }
  }
}
</script>

<style scoped>
.noMenu{
  height: calc(100% - 32px);
}
</style>
